module.exports = __webpack_public_path__ + "a9c7c20a417a34a9d017176b563cfb64.woff2";